import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import styles from './Hero.module.postcss';

function Hero({ children, photo }) {
  return (
    <>
      <Helmet>
        <link rel='preload' as='image' href={photo} fetchpriority='high' />
      </Helmet>

      <div className={styles.Hero}>
        <div
          className={styles.Hero_image}
          style={photo && { backgroundImage: `url("${photo}")` }}
        />
        <div className={styles.Hero_content}>
          {children}
        </div>
      </div>
    </>
  );
}

Hero.propTypes = {
  children: PropTypes.node,
  photo: PropTypes.string,
};

export default Hero;
